export const actions = {
    addModalWindow({ commit }, modal) {
        commit('addModalWindow', modal)
    },
    removeModalWindow({ commit }, { modal }) {
        commit('removeModalWindow', modal)
    },
}